module.exports = __webpack_public_path__ + "static/plans-start-dr-form-5cfed054d41d3a0fd3165ef57af7a51b.png";